import React, { createContext, useState, useEffect } from 'react';
import { authService } from '../services/authService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUser = authService.getCurrentUser();
    setUser(currentUser);
    setLoading(false);
  }, []);

  const refreshUser = () => {
    setUser(authService.getCurrentUser());
  };

  const login = async (email, password, recaptchaToken) => {
    const data = await authService.login(email, password, recaptchaToken);
    setUser(data.user ?? authService.getCurrentUser());
    return data;
  };

  const register = async (firstName, lastName, email, password, passwordConfirm) => {
    try {
      const data = await authService.register(firstName, lastName, email, password, passwordConfirm);
      const userData = authService.getCurrentUser();
      setUser(userData);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const registerChimney = async (firstName, lastName, email, password, passwordConfirm, companyName, city, phone, description) => {
    try {
      const data = await authService.registerChimney(firstName, lastName, email, password, passwordConfirm, companyName, city, phone, description);
      const userData = authService.getCurrentUser();
      setUser(userData);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  const isChimney = () => {
    return user && user.role === 'chimney';
  };

  const isAdmin = () => {
    return user && user.is_staff === true;
  };

  const value = {
    user,
    login,
    register,
    registerChimney,
    logout,
    refreshUser,
    isChimney,
    isAdmin,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
